/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('.photo-gallery').magnificPopup({
	  type: 'image',
	  delegate: 'a',
	  gallery:{
	    enabled:true
	  }
	});



});

jQuery(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    jQuery('html, body').animate({
        scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
    }, 500);
});

//Google Maps JS
//Set Map
function initialize() {
		var myLatlng = new google.maps.LatLng(49.606698,6.402115);
		var center = new google.maps.LatLng(49.606698,6.402115);
		var imagePath = 'http://m.schuepfen.ch/icons/helveticons/black/60/Pin-location.png'
		var mapOptions = {
			zoom: 13,
			center: center,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#9b9b9b"},{"visibility":"on"}]}]
		}

	var map = new google.maps.Map(document.getElementById('map'), mapOptions);
	//Callout Content
	var contentString = '<strong>Racing Experience</strong><br>49, Rue Principale<br>L-5480 Wormeldange Luxembourg';
	//Set window width + content
	var infowindow = new google.maps.InfoWindow({
		content: contentString,
		maxWidth: 500
	});

	//Add Marker
	var marker = new google.maps.Marker({
		position: myLatlng,
		map: map,
		icon: imagePath,
		title: 'image title'
	});

	google.maps.event.addListener(marker, 'click', function() {
		infowindow.open(map,marker);
	});

	//Resize Function
	google.maps.event.addDomListener(window, "resize", function() {
		var center = map.getCenter();
		google.maps.event.trigger(map, "resize");
		map.setCenter(center);
	});
}